import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const image = {
  addImage: lazyModuleMethod(() => import('./addImage'), 'default'),
  addImageSupport: lazyModuleMethod(
    () => import('./addImageSupport'),
    'default'
  ),
  addImageByUrl: lazyModuleMethod(() => import('./addImageByUrl'), 'default'),
  addImageTransform: lazyModuleMethod(
    () => import('./addImageTransform'),
    'default'
  ),
  fetchImagePurposes: lazyModuleMethod(
    () => import('./fetchImagePurposes'),
    'default'
  ),
  changeImageTransform: lazyModuleMethod(
    () => import('./changeImageTransform'),
    'default'
  ),
  addImageFake: lazyModuleMethod(() => import('./addImageFake'), 'default'),
  fetchImage: lazyModuleMethod(() => import('./fetchImage'), 'default'),
  fetchConstructorMeta: lazyModuleMethod(
    () => import('./fetchConstructorMeta'),
    'default'
  ),
  fetchImageTransform: lazyModuleMethod(
    () => import('./fetchImageTransform'),
    'default'
  ),
}
